import clsx from 'clsx'
import type { Checklist as ChecklistModel } from 'lib/community/discussions-writer'
import base from 'components/community/community.module.css'
import styles from './Writer.module.css'

/** The live checklist card (design 10b). Advice only: it never blocks posting. */
const Checklist: React.VFC<{ checklist: ChecklistModel }> = ({ checklist }) => (
  <section className={clsx(base.card, base.cardInfo)} aria-label="Checklist">
    <h2 className={styles.checkTitle} aria-live="polite">
      {checklist.title}
    </h2>
    <ul className={styles.checks}>
      {checklist.items.map(item => (
        <li key={item.label} className={clsx(styles.check, { [styles.checkDone]: item.done })}>
          <span className={styles.checkMark} aria-hidden="true">
            {item.done ? '✓' : ''}
          </span>
          <span className={styles.checkLabel}>
            {item.label}
            <span className={styles.srOnly}>{item.done ? ' (done)' : ' (not yet)'}</span>
          </span>
        </li>
      ))}
    </ul>
  </section>
)

export default Checklist
